import { IUser } from "Application/features/models/Home/IUser";
import { ILogin } from "../../../models/Auth/Login";
import { IUserPasswordUpdate } from "../../../models/Auth/UserPasswordUpdate";
import { queryResponse, sibaAuthApi } from "../../backends/sibaApis";

const api = "api/Account";
/***
 * service definition for Title setup
 *  */
const AuthApi = sibaAuthApi.injectEndpoints({
    //endpoints: (builder) => SibaBackendBaseEndpoints<ITitle>('Titleconfiguration', builder)
    endpoints: (builder) => ({
        /**
         * Reset  endpoint
         * query expects object of type country model.
         */
        savePasswordReset: builder.mutation<queryResponse<string>, string>({
            query: (email: string) => ({
                url: `${api}/recovery/reset`,
                method: "POST",
                data: email
            })
        }),
        
        /**
         * save  endpoint
         * query expects object of type country model.
         */
        login: builder.mutation<queryResponse<any>, ILogin>({
            query: (obj: ILogin) => ({
                url: `${api}/login`,
                method: "POST",
                data: obj
            })
        }),
        logout: builder.mutation<queryResponse<any>, string>({
            query: (email: string) => ({
                url: `${api}/reset`,
                method: "POST",
                data: email
            })
        }),
        updateUserPassword: builder.mutation<queryResponse<any>, IUserPasswordUpdate>({
            query: (obj: IUserPasswordUpdate) => ({
                url: `${api}/first/time/password`,
                method: "PUT",
                data: obj
            })
        })
    })
    // getUserLovGuid: builder.mutation<IUser[], void>({
    //     query: () => ({
    //         url: `${api}/lov`,
    //         method: 'GET'
    //     })
    // }),
    // /**
    //  * Sample query method using rtk mutation instead of rtk query.
    //  */
    // getUserLovCode: builder.mutation<IUser[], void>({
    //     query: () => ({
    //         url: `${api}/lov?code=true`,
    //         method: 'GET'
    //     })
    // })
});

export const { useSavePasswordResetMutation, useLoginMutation, useUpdateUserPasswordMutation, useLogoutMutation } = AuthApi;
